import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Box, Typography, useTheme } from '@mui/material'
import { i18nTranslationHelper } from '@/i18n'

type ModalHeaderProps = {
  titleKey: string
  descriptionKey: string
}

/**
 * O cabeçalho dos modais que pedem uma mensagem da Sofie no WhatsApp.
 *
 * Extraído do fluxo da mentoria de carreira para ser compartilhado com o convite do app — mesma
 * marca, mesmo arranjo, só mudam os textos.
 */
export default function ModalHeader({ titleKey, descriptionKey }: Readonly<ModalHeaderProps>) {
  const t = i18nTranslationHelper.getTComponents
  const theme = useTheme()

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
      <Box
        sx={{
          backgroundColor: theme.palette.success[50],
          borderRadius: '50%',
          width: 48,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        role="img"
        aria-label={t('whatsappModal.iconAriaLabel')}
      >
        <WhatsAppIcon sx={{ fontSize: 24, color: theme.palette.success[500] }} aria-hidden="true" />
      </Box>

      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Typography variant="h6" fontWeight="bold" textAlign="center" component="h2">
          {t(titleKey)}
        </Typography>

        <Typography variant="body1" color="text.primary" textAlign="center" whiteSpace="pre-line">
          {t(descriptionKey)}
        </Typography>
      </Box>
    </Box>
  )
}
